import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('layout.sidebar');
import { OnInit } from '@angular/core';
import { HostListener } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-layout-sidebar',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/layout.sidebar/view.scss */
:host {
  display: block;
  height: 100%;
  min-width: 0;
}

.nf-app-shell {
  display: flex;
  width: 100%;
  height: 100vh;
  min-height: 0;
  overflow: hidden;
  background: var(--nf-page-bg, #f6f8fb);
  color: var(--nf-ink, #0f172a);
}

.nf-desktop-sidebar {
  position: relative;
  z-index: 30;
  display: flex;
  width: 264px;
  min-width: 264px;
  height: 100%;
  flex: 0 0 264px;
  flex-direction: column;
  overflow: hidden;
  background: #08162b;
  transition: width 0.2s ease, min-width 0.2s ease, flex-basis 0.2s ease;
}

.nf-desktop-sidebar.is-collapsed {
  width: 76px;
  min-width: 76px;
  flex-basis: 76px;
}

.nf-workspace {
  position: relative;
  display: flex;
  min-width: 0;
  min-height: 0;
  flex: 1 1 auto;
  flex-direction: column;
  overflow: hidden;
}

.nf-topbar {
  position: relative;
  z-index: 50;
  display: flex;
  width: 100%;
  height: 64px;
  min-height: 64px;
  align-items: center;
  gap: 20px;
  border-bottom: 1px solid #e6e9ef;
  background: #ffffff;
  padding: 0 24px;
  box-shadow: 0 1px 0 rgba(15, 23, 42, 0.02);
}

.nf-topbar-primary {
  display: flex;
  min-width: 0;
  flex: 1 1 auto;
  align-items: center;
  gap: 12px;
}

.nf-mobile-menu-button,
.nf-mobile-search-button,
.nf-topbar-icon {
  display: inline-flex;
  width: 40px;
  height: 40px;
  flex: 0 0 40px;
  align-items: center;
  justify-content: center;
  border: 1px solid transparent;
  border-radius: 9px;
  background: transparent;
  color: #536174;
  font-size: 17px;
  transition: border-color 0.16s ease, background-color 0.16s ease, color 0.16s ease;
}

.nf-mobile-menu-button:hover,
.nf-mobile-search-button:hover,
.nf-topbar-icon:hover,
.nf-topbar-icon[aria-expanded=true] {
  border-color: #dfe5ee;
  background: #f5f7fa;
  color: #0f172a;
}

.nf-mobile-menu-button:focus-visible,
.nf-mobile-search-button:focus-visible,
.nf-topbar-icon:focus-visible,
.nf-website-link:focus-visible,
.nf-user-profile:focus-visible,
.nf-header-search:focus-within {
  outline: 3px solid rgba(18, 104, 255, 0.18);
  outline-offset: 2px;
}

.nf-mobile-menu-button,
.nf-mobile-search-button,
.nf-mobile-brand {
  display: none;
}

.nf-mobile-brand {
  min-width: 0;
  align-items: center;
  gap: 7px;
}

.nf-mobile-brand img {
  display: block;
  width: auto;
  max-width: 142px;
  height: 34px;
  object-fit: contain;
}

.nf-mobile-brand strong {
  color: #051946;
  font-size: 14px;
  font-weight: 800;
  white-space: nowrap;
}

.nf-header-search {
  display: flex;
  width: min(400px, 42vw);
  height: 40px;
  min-width: 240px;
  align-items: center;
  gap: 10px;
  border: 1px solid #eef0f4;
  border-radius: 9px;
  background: #f3f4f7;
  padding: 0 12px;
  color: #909bac;
  transition: border-color 0.16s ease, background-color 0.16s ease, box-shadow 0.16s ease;
}

.nf-header-search:focus-within {
  border-color: #9ec2ff;
  background: #ffffff;
  box-shadow: 0 0 0 3px rgba(18, 104, 255, 0.08);
}

.nf-header-search > i {
  flex: none;
  font-size: 14px;
}

.nf-header-search input,
.nf-mobile-search input {
  min-width: 0;
  flex: 1 1 auto;
  border: 0 !important;
  outline: 0;
  background: transparent !important;
  box-shadow: none !important;
  color: #182033 !important;
  font-size: 13px;
  font-weight: 500;
}

.nf-header-search input {
  height: 38px;
  padding: 0 !important;
}

.nf-header-search input::placeholder,
.nf-mobile-search input::placeholder {
  color: #98a3b4 !important;
}

.nf-search-clear {
  display: inline-flex;
  width: 24px;
  height: 24px;
  flex: none;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: #9aa5b5;
  font-size: 12px;
}

.nf-search-clear:hover {
  background: #e5e9ef;
  color: #4c596d;
}

.nf-topbar-actions {
  display: flex;
  min-width: 0;
  flex: 0 0 auto;
  align-items: center;
  gap: 4px;
}

.nf-website-link {
  display: inline-flex;
  height: 38px;
  align-items: center;
  gap: 7px;
  border-radius: 8px;
  background: #eff6ff;
  padding: 0 13px;
  color: #0967e8;
  font-size: 13px;
  font-weight: 750;
  text-decoration: none;
  transition: background-color 0.16s ease, color 0.16s ease;
}

.nf-website-link:hover {
  background: #e1eeff;
  color: #0757c7;
}

.nf-website-link i {
  font-size: 12px;
}

.nf-topbar-divider {
  display: block;
  width: 1px;
  height: 28px;
  margin: 0 8px;
  background: #e8ebf0;
}

.nf-user-profile {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 10px;
  margin-left: 6px;
  border-radius: 10px;
  padding: 4px 6px;
  color: #49566a;
  text-decoration: none;
  transition: background-color 0.16s ease;
}

.nf-user-profile:hover {
  background: #f5f7fa;
}

.nf-user-avatar {
  display: inline-flex;
  width: 38px;
  height: 38px;
  flex: 0 0 38px;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  background: #e7f1ff;
  color: #0967e8;
  font-size: 14px;
  font-weight: 800;
}

.nf-user-copy {
  display: flex;
  min-width: 0;
  max-width: 132px;
  flex-direction: column;
}

.nf-user-copy strong,
.nf-user-copy small {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.nf-user-copy strong {
  color: #4d596b;
  font-size: 13px;
  font-weight: 700;
  line-height: 1.25;
}

.nf-user-copy small {
  margin-top: 2px;
  color: #9aa5b4;
  font-size: 12px;
  line-height: 1.2;
}

.nf-header-popover {
  position: absolute;
  top: 54px;
  z-index: 85;
  width: 300px;
  overflow: hidden;
  border: 1px solid #dfe5ed;
  border-radius: 12px;
  background: #ffffff;
  box-shadow: 0 18px 48px rgba(15, 23, 42, 0.16);
}

.nf-header-popover > header {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
  border-bottom: 1px solid #edf0f4;
  padding: 13px 15px 11px;
}

.nf-header-popover > header strong {
  color: #172033;
  font-size: 14px;
  font-weight: 800;
}

.nf-header-popover > header span {
  color: #9aa5b4;
  font-size: 12px;
}

.nf-apps-popover {
  right: 222px;
}

.nf-notification-popover {
  right: 174px;
}

.nf-app-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
  padding: 12px;
}

.nf-app-grid a {
  display: flex;
  min-width: 0;
  min-height: 72px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border: 1px solid #edf0f4;
  border-radius: 10px;
  background: #fafbfc;
  color: #4b596e;
  text-decoration: none;
  transition: border-color 0.16s ease, background-color 0.16s ease, color 0.16s ease;
}

.nf-app-grid a:hover {
  border-color: #b7d1ff;
  background: #eff6ff;
  color: #0967e8;
}

.nf-app-grid i {
  font-size: 17px;
}

.nf-app-grid span {
  max-width: 100%;
  overflow: hidden;
  font-size: 12px;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.nf-notification-empty {
  display: flex;
  align-items: flex-start;
  gap: 11px;
  padding: 18px 15px 20px;
}

.nf-notification-empty > span {
  display: inline-flex;
  width: 32px;
  height: 32px;
  flex: 0 0 32px;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  background: #e7f8f0;
  color: #089465;
  font-size: 12px;
}

.nf-notification-empty strong {
  display: block;
  color: #334155;
  font-size: 12px;
  font-weight: 750;
}

.nf-notification-empty p {
  margin: 4px 0 0;
  color: #8a96a8;
  font-size: 12px;
  line-height: 1.5;
}

.nf-mobile-search {
  display: none;
}

.nf-main-surface {
  min-width: 0;
  min-height: 0;
  flex: 1 1 auto;
  overflow: auto;
}

.nf-mobile-sidebar,
.nf-mobile-sidebar-backdrop {
  display: none;
}

:host-context([data-theme=dark]) .nf-topbar,
:host-context([data-theme=dark]) .nf-mobile-search,
:host-context([data-theme=dark]) .nf-header-popover {
  border-color: #26384d;
  background: #0f1e31;
}

:host-context([data-theme=dark]) .nf-topbar {
  box-shadow: 0 1px 0 rgba(255, 255, 255, 0.03);
}

:host-context([data-theme=dark]) .nf-header-search {
  border-color: #25384d;
  background: #101c2d;
  color: #71869c;
}

:host-context([data-theme=dark]) .nf-header-search:focus-within {
  border-color: #2a89ba;
  background: #101c2d;
}

:host-context([data-theme=dark]) .nf-header-search input,
:host-context([data-theme=dark]) .nf-mobile-search input {
  color: #e5eef8 !important;
}

:host-context([data-theme=dark]) .nf-topbar-icon,
:host-context([data-theme=dark]) .nf-mobile-menu-button,
:host-context([data-theme=dark]) .nf-mobile-search-button,
:host-context([data-theme=dark]) .nf-user-copy strong {
  color: #c6d4e4;
}

:host-context([data-theme=dark]) .nf-topbar-icon:hover,
:host-context([data-theme=dark]) .nf-topbar-icon[aria-expanded=true],
:host-context([data-theme=dark]) .nf-mobile-menu-button:hover,
:host-context([data-theme=dark]) .nf-mobile-search-button:hover,
:host-context([data-theme=dark]) .nf-user-profile:hover {
  border-color: #2a4059;
  background: #14283d;
  color: #ffffff;
}

:host-context([data-theme=dark]) .nf-topbar-divider,
:host-context([data-theme=dark]) .nf-header-popover > header {
  border-color: #26384d;
  background-color: transparent;
}

:host-context([data-theme=dark]) .nf-header-popover > header strong,
:host-context([data-theme=dark]) .nf-notification-empty strong {
  color: #e5eef8;
}

:host-context([data-theme=dark]) .nf-app-grid a {
  border-color: #24394f;
  background: #101c2d;
  color: #aabbd0;
}

:host-context([data-theme=dark]) .nf-app-grid a:hover {
  border-color: #2f82ad;
  background: #13283f;
  color: #87d7ff;
}

@media (max-width: 1199px) {
  .nf-topbar {
    gap: 12px;
    padding: 0 18px;
  }
  .nf-header-search {
    width: min(340px, 36vw);
  }
  .nf-user-copy {
    display: none;
  }
  .nf-apps-popover {
    right: 174px;
  }
  .nf-notification-popover {
    right: 126px;
  }
}
@media (max-width: 1023px) {
  .nf-desktop-sidebar {
    display: none;
  }
  .nf-topbar {
    padding: 0 16px;
  }
  .nf-mobile-menu-button,
  .nf-mobile-brand {
    display: inline-flex;
  }
  .nf-header-search {
    width: min(360px, 42vw);
    min-width: 180px;
  }
  .nf-mobile-sidebar {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    z-index: 100;
    display: flex;
    width: min(320px, 88vw);
    flex-direction: column;
    overflow: hidden;
    background: #08162b;
    box-shadow: 18px 0 48px rgba(3, 11, 24, 0.28);
    transform: translateX(-102%);
    visibility: hidden;
    transition: transform 0.22s ease, visibility 0.22s ease;
  }
  .nf-mobile-sidebar.is-open {
    transform: translateX(0);
    visibility: visible;
  }
  .nf-mobile-sidebar-backdrop {
    position: fixed;
    inset: 0;
    z-index: 95;
    display: block;
    border: 0;
    background: rgba(4, 12, 26, 0.58);
    backdrop-filter: blur(2px);
  }
  .nf-apps-popover {
    right: 178px;
  }
  .nf-notification-popover {
    right: 130px;
  }
}
@media (max-width: 767px) {
  .nf-topbar {
    gap: 8px;
    padding: 0 12px;
  }
  .nf-topbar-primary {
    gap: 8px;
  }
  .nf-mobile-brand img {
    max-width: 124px;
    height: 30px;
  }
  .nf-header-search {
    width: auto;
    min-width: 140px;
    flex: 1 1 auto;
  }
  .nf-website-link,
  .nf-apps-button,
  .nf-topbar-divider {
    display: none;
  }
  .nf-topbar-actions {
    gap: 0;
  }
  .nf-user-profile {
    margin-left: 2px;
    padding: 2px;
  }
  .nf-user-avatar {
    width: 36px;
    height: 36px;
    flex-basis: 36px;
  }
  .nf-notification-popover {
    right: 54px;
  }
}
@media (max-width: 639px) {
  .nf-mobile-brand {
    flex: 1 1 auto;
  }
  .nf-header-search {
    display: none;
  }
  .nf-mobile-search-button {
    display: inline-flex;
  }
  .nf-notification-button {
    display: none;
  }
  .nf-mobile-search {
    position: relative;
    z-index: 45;
    display: flex;
    height: 58px;
    flex: 0 0 58px;
    align-items: center;
    gap: 10px;
    border-bottom: 1px solid #e6e9ef;
    background: #ffffff;
    padding: 8px 12px;
    color: #909bac;
  }
  .nf-mobile-search input {
    height: 40px;
    border: 1px solid #e2e7ee !important;
    border-radius: 9px;
    background: #f5f6f8 !important;
    padding: 0 12px !important;
  }
  .nf-mobile-search > button {
    height: 40px;
    flex: 0 0 auto;
    border: 0;
    border-radius: 9px;
    background: #1268ff;
    padding: 0 14px;
    color: #ffffff;
    font-size: 12px;
    font-weight: 750;
  }
  .nf-settings-button {
    display: none;
  }
  .nf-header-popover {
    top: 56px;
    right: 12px;
    width: min(300px, 100vw - 24px);
  }
}
@media (max-width: 380px) {
  .nf-mobile-brand img {
    max-width: 108px;
  }
  .nf-mobile-menu-button,
  .nf-mobile-search-button,
  .nf-topbar-icon {
    width: 36px;
    height: 36px;
    flex-basis: 36px;
  }
}
.nf-floating-chat {
  position: fixed;
  right: 22px;
  bottom: 22px;
  z-index: 45;
  pointer-events: none;
}

.nf-floating-chat.is-agent-chat {
  bottom: 92px;
}

.nf-floating-chat > * {
  pointer-events: auto;
}

.nf-floating-chat-launcher {
  position: relative;
  display: flex;
  width: 58px;
  height: 58px;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border: 1px solid #b8cae1;
  border-radius: 999px;
  background: #ffffff;
  box-shadow: 0 18px 42px rgba(15, 23, 42, 0.2);
  transition: transform 0.16s ease, box-shadow 0.16s ease, border-color 0.16s ease;
}

.nf-floating-chat-launcher:hover {
  border-color: #2e6fae;
  box-shadow: 0 20px 52px rgba(46, 111, 174, 0.28);
  transform: translateY(-2px);
}

.nf-floating-chat-launcher:focus-visible {
  outline: 3px solid rgba(46, 111, 174, 0.24);
  outline-offset: 3px;
}

.nf-floating-chat-launcher-face {
  width: 54px;
  height: 54px;
  object-fit: contain;
}

.nf-floating-chat-launcher-dot {
  position: absolute;
  right: 3px;
  bottom: 3px;
  display: inline-flex;
  width: 21px;
  min-width: 21px;
  height: 21px;
  align-items: center;
  justify-content: center;
  border: 2px solid #ffffff;
  border-radius: 999px;
  background: #153e66;
  color: #ffffff;
  font-size: 12px;
  font-weight: 700;
  line-height: 1;
}

.nf-floating-chat-panel {
  display: grid;
  width: min(390px, 100vw - 32px);
  height: min(740px, 100vh - 122px);
  max-height: min(740px, 100vh - 122px);
  grid-template-rows: auto minmax(300px, 1fr) auto auto;
  overflow: hidden;
  border: 1px solid #c8d6e8;
  border-radius: 18px;
  background: #ffffff;
  box-shadow: 0 24px 70px rgba(15, 23, 42, 0.24);
}

.nf-floating-chat-header {
  display: flex;
  min-height: 66px;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  border-bottom: 1px solid #e8edf5;
  padding: 10px 12px 10px 14px;
}

.nf-floating-chat-title {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 10px;
}

.nf-floating-chat-title strong,
.nf-floating-chat-title small {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.nf-floating-chat-title strong {
  color: #0f172a;
  font-size: 14px;
  font-weight: 700;
}

.nf-floating-chat-title small {
  margin-top: 2px;
  color: #64748b;
  font-size: 12px;
}

.nf-floating-chat-face-wrap {
  display: flex;
  width: 42px;
  height: 42px;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border: 1px solid #d9e1ec;
  border-radius: 999px;
  background: #f7fbff;
}

.nf-floating-chat-face {
  width: 40px;
  height: 40px;
  object-fit: contain;
}

.nf-floating-chat-actions {
  display: flex;
  flex: 0 0 auto;
  gap: 6px;
}

.nf-floating-chat-actions button {
  display: inline-flex;
  width: 32px;
  height: 32px;
  align-items: center;
  justify-content: center;
  border: 1px solid #d9e1ec;
  border-radius: 8px;
  background: #ffffff;
  color: #475569;
}

.nf-floating-chat-actions button:hover {
  border-color: #a9c7ff;
  background: #edf6ff;
  color: #153e66;
}

.nf-floating-chat-actions svg {
  width: 16px;
  height: 16px;
}

.nf-floating-chat-body {
  min-height: 0;
  overflow-y: auto;
  background: #f7f9fc;
  padding: 14px;
}

.nf-floating-chat-message {
  width: fit-content;
  max-width: 88%;
  margin-bottom: 10px;
  border: 1px solid #d9e1ec;
  border-radius: 14px;
  background: #ffffff;
  padding: 9px 11px;
  color: #0f172a;
  box-shadow: 0 8px 24px rgba(37, 99, 235, 0.08);
}

.nf-floating-chat-message p {
  margin: 0;
  white-space: pre-wrap;
  font-size: 13px;
  line-height: 1.58;
}

.nf-floating-chat-message.is-user {
  margin-left: auto;
  border-color: #153e66;
  background: #153e66;
  color: #ffffff;
  box-shadow: none;
}

.nf-floating-chat-message.is-error {
  border-color: #fecdd3;
  background: #fff1f2;
  color: #be123c;
}

.nf-floating-chat-runtime {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  margin-top: 8px;
}

.nf-floating-chat-runtime span {
  border: 1px solid #d9e1ec;
  border-radius: 999px;
  background: #f8fafc;
  padding: 3px 7px;
  color: #475569;
  font-size: 12px;
  font-weight: 650;
  line-height: 1.35;
}

.nf-floating-chat-runtime span.is-sample,
.nf-floating-chat-runtime span.is-warning {
  border-color: #f5c46b;
  background: #fffbeb;
  color: #92400e;
}

.nf-floating-chat-citations {
  display: grid;
  gap: 4px;
  margin-top: 8px;
  border-top: 1px solid #e8edf5;
  padding-top: 8px;
}

.nf-floating-chat-citations span {
  color: #64748b;
  font-size: 12px;
  line-height: 1.4;
}

.nf-floating-chat-links,
.nf-floating-chat-followups,
.nf-floating-chat-suggestions {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 8px;
}

.nf-floating-chat-links a,
.nf-floating-chat-followups button,
.nf-floating-chat-suggestions button {
  max-width: 100%;
  border: 1px solid #d9e1ec;
  border-radius: 999px;
  background: #ffffff;
  padding: 5px 9px;
  color: #475569;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.2;
  text-decoration: none;
}

.nf-floating-chat-links a:hover,
.nf-floating-chat-followups button:hover,
.nf-floating-chat-suggestions button:hover {
  border-color: #a9c7ff;
  background: #edf6ff;
  color: #153e66;
}

.nf-floating-chat-suggestions {
  margin: 0;
  border-top: 1px solid #e8edf5;
  padding: 10px 12px 0;
}

.nf-floating-chat-message.is-loading {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 12px;
}

.nf-floating-chat-message.is-loading span {
  width: 6px;
  height: 6px;
  border-radius: 999px;
  background: #2e6fae;
  animation: nf-floating-chat-bounce 0.9s infinite ease-in-out;
}

.nf-floating-chat-message.is-loading span:nth-child(2) {
  animation-delay: 0.12s;
}

.nf-floating-chat-message.is-loading span:nth-child(3) {
  animation-delay: 0.24s;
}

.nf-floating-chat-composer {
  display: grid;
  gap: 8px;
  padding: 10px 12px 12px;
}

.nf-floating-chat-composer textarea {
  width: 100%;
  min-height: 58px;
  resize: none;
  border: 1px solid #c8d6e8;
  border-radius: 12px;
  background: #ffffff;
  padding: 9px 10px;
  color: #0f172a;
  font-size: 13px;
  line-height: 1.5;
}

.nf-floating-chat-composer textarea:focus {
  border-color: #2e6fae;
  box-shadow: 0 0 0 3px rgba(46, 111, 174, 0.12);
  outline: none;
}

.nf-floating-chat-composer-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
}

.nf-floating-chat-key-hint {
  margin-right: auto;
  color: #64748b;
  font-size: 12px;
  line-height: 1.3;
}

.nf-floating-chat-secondary,
.nf-floating-chat-submit {
  height: 34px;
  border-radius: 999px;
  padding: 0 13px;
  font-size: 12px;
  font-weight: 700;
}

.nf-floating-chat-secondary {
  border: 1px solid #d9e1ec;
  background: #ffffff;
  color: #475569;
}

.nf-floating-chat-submit {
  border: 1px solid #153e66;
  background: #153e66;
  color: #ffffff;
}

.nf-floating-chat-submit:disabled {
  cursor: not-allowed;
  opacity: 0.45;
}

@keyframes nf-floating-chat-bounce {
  0%, 80%, 100% {
    transform: translateY(0);
    opacity: 0.45;
  }
  40% {
    transform: translateY(-4px);
    opacity: 1;
  }
}
:host-context([data-theme=dark]) .nf-floating-chat-panel {
  border-color: rgba(148, 163, 184, 0.34);
  background: #0f172a;
  box-shadow: 0 24px 70px rgba(0, 0, 0, 0.44);
}

:host-context([data-theme=dark]) .nf-floating-chat-header,
:host-context([data-theme=dark]) .nf-floating-chat-suggestions {
  border-color: rgba(148, 163, 184, 0.22);
}

:host-context([data-theme=dark]) .nf-floating-chat-body {
  background: #071321;
}

:host-context([data-theme=dark]) .nf-floating-chat-title strong,
:host-context([data-theme=dark]) .nf-floating-chat-message,
:host-context([data-theme=dark]) .nf-floating-chat-composer textarea {
  color: #e5eef8;
}

:host-context([data-theme=dark]) .nf-floating-chat-message,
:host-context([data-theme=dark]) .nf-floating-chat-actions button,
:host-context([data-theme=dark]) .nf-floating-chat-composer textarea,
:host-context([data-theme=dark]) .nf-floating-chat-secondary,
:host-context([data-theme=dark]) .nf-floating-chat-links a,
:host-context([data-theme=dark]) .nf-floating-chat-followups button,
:host-context([data-theme=dark]) .nf-floating-chat-suggestions button {
  border-color: rgba(148, 163, 184, 0.28);
  background: #111c2e;
}

@media (max-width: 640px) {
  .nf-floating-chat {
    right: 12px;
    bottom: 14px;
    left: 12px;
  }
  .nf-floating-chat.is-agent-chat {
    bottom: 14px;
  }
  .nf-floating-chat-launcher {
    margin-left: auto;
  }
  .nf-floating-chat-panel {
    width: 100%;
    height: calc(100vh - 86px);
    max-height: calc(100vh - 86px);
    border-radius: 14px;
  }
}`],
})
export class LayoutSidebarComponent implements OnInit {
    public theme: string = 'light';
    public sidebarCollapsed: boolean = false;
    public mobileSidebarOpen: boolean = false;
    public mobileSearchOpen: boolean = false;
    public headerSearch: string = '';
    public headerPanel: string = '';
    public floatingChatOpen: boolean = false;
    public floatingChatInput: string = '';
    public floatingChatAsking: boolean = false;
    public floatingChatMessages: any[] = [
        {
            role: 'assistant',
            content: 'NanoFab Studio와 공정 데이터 질문을 도와드릴게요.',
            followups: ['이 사이트에서 무엇을 할 수 있어?', 'Lot A13 수율 하락 원인을 알려줘', 'AI 인터페이스 기능을 알려줘']
        }
    ];
    public floatingChatSuggestions: string[] = [
        '이 사이트에서 무엇을 할 수 있어?',
        'Lot A13 수율 하락 원인을 알려줘',
        'AI 인터페이스 기능을 알려줘'
    ];
    private themeStorageKey: string = 'nanofab.theme';
    private sidebarStorageKey: string = 'nanofab.sidebar.collapsed';

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.status.toggle('navbar', false);
        this.sidebarCollapsed = this.detectSidebarCollapsed();
        this.applyTheme(this.detectTheme());
    }

    @HostListener('document:click')
    public clickout() {
        this.service.status.toggle('navbar', false);
        this.headerPanel = '';
    }

    @HostListener('document:keydown.escape')
    public async handleEscape() {
        if (!this.mobileSidebarOpen && !this.mobileSearchOpen && !this.headerPanel) return;
        this.mobileSidebarOpen = false;
        this.mobileSearchOpen = false;
        this.headerPanel = '';
        await this.service.render();
    }

    @HostListener('window:resize')
    public async handleViewportResize() {
        if (window.innerWidth < 1024 || (!this.mobileSidebarOpen && !this.mobileSearchOpen)) return;
        this.mobileSidebarOpen = false;
        this.mobileSearchOpen = false;
        await this.service.render();
    }

    @HostListener('window:nanofab-sidebar-collapse', ['$event'])
    public async onSidebarCollapse(event: CustomEvent) {
        this.sidebarCollapsed = !!event.detail;
        await this.service.render();
    }

    @HostListener('window:nanofab-mobile-sidebar-close')
    public async handleMobileSidebarClose() {
        if (!this.mobileSidebarOpen) return;
        this.mobileSidebarOpen = false;
        await this.service.render();
    }

    public isActive(link: string) {
        return location.pathname.indexOf(link) === 0
    }

    public isAdmin() {
        return this.service.auth.session?.role === 'admin';
    }

    public async toggleMobileSidebar(event?: Event) {
        if (event) event.stopPropagation();
        this.mobileSidebarOpen = !this.mobileSidebarOpen;
        this.mobileSearchOpen = false;
        this.headerPanel = '';
        await this.service.render();
    }

    public async closeMobileSidebar() {
        if (!this.mobileSidebarOpen) return;
        this.mobileSidebarOpen = false;
        await this.service.render();
    }

    public async toggleMobileSearch(event?: Event) {
        if (event) event.stopPropagation();
        this.mobileSearchOpen = !this.mobileSearchOpen;
        this.mobileSidebarOpen = false;
        this.headerPanel = '';
        await this.service.render();
        if (this.mobileSearchOpen) {
            setTimeout(() => {
                const input = document.querySelector('.nf-mobile-search input') as HTMLInputElement;
                if (input) input.focus();
            }, 0);
        }
    }

    public async toggleHeaderPanel(panel: string, event?: Event) {
        if (event) event.stopPropagation();
        this.headerPanel = this.headerPanel === panel ? '' : panel;
        this.mobileSidebarOpen = false;
        await this.service.render();
    }

    public closeHeaderPanel() {
        this.headerPanel = '';
    }

    public submitHeaderSearch(event?: Event) {
        if (event) event.preventDefault();
        const query = String(this.headerSearch || '').trim();
        if (!query) return;
        this.mobileSearchOpen = false;
        this.headerPanel = '';
        location.href = `/agent/history?q=${encodeURIComponent(query)}`;
    }

    public async clearHeaderSearch(event?: Event) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        this.headerSearch = '';
        await this.service.render();
        const input = document.querySelector('.nf-header-search input') as HTMLInputElement;
        if (input) input.focus();
    }

    public settingsRoute() {
        return this.isAdmin() ? '/agent/admin' : '/mypage';
    }

    public operationsRoute() {
        return this.isAdmin() ? '/agent/quality' : '/agent/training';
    }

    public websiteUrl() {
        return `${window.location.origin}/dashboard`;
    }

    public userInitial() {
        const name = String(this.service.auth.session?.name || this.service.auth.session?.email || 'U').trim();
        return name.charAt(0).toUpperCase() || 'U';
    }

    public userRoleLabel() {
        return this.isAdmin() ? 'Administrator' : 'Member';
    }

    public async toggleTheme(event?: Event) {
        if (event) event.stopPropagation();
        this.applyTheme(this.theme === 'dark' ? 'light' : 'dark');
        await this.service.render();
    }

    public themeLabel() {
        return this.theme === 'dark' ? '화이트 모드로 전환' : '다크 모드로 전환';
    }

    public floatingChatClass() {
        return {
            'is-open': this.floatingChatOpen,
            'is-agent-chat': this.isActive('/agent/chat')
        };
    }

    public async toggleFloatingChat(event?: Event) {
        if (event) event.stopPropagation();
        this.floatingChatOpen = !this.floatingChatOpen;
        await this.service.render();
        if (this.floatingChatOpen) this.scrollFloatingChatToBottom();
    }

    public async closeFloatingChat(event?: Event) {
        if (event) event.stopPropagation();
        this.floatingChatOpen = false;
        await this.service.render();
    }

    public async resetFloatingChat() {
        this.floatingChatMessages = [
            {
                role: 'assistant',
                content: '새 질문을 입력해 주세요. 사이트 안내, 공정 데이터, AI 분석 기능을 바로 확인할 수 있습니다.',
                followups: this.floatingChatSuggestions
            }
        ];
        this.floatingChatInput = '';
        await this.service.render();
    }

    public async selectFloatingSuggestion(text: string) {
        this.floatingChatInput = text;
        await this.floatingChatAsk();
    }

    public async floatingChatAsk() {
        const message = (this.floatingChatInput || '').trim();
        if (!message || this.floatingChatAsking) return;

        this.floatingChatMessages.push({ role: 'user', content: message });
        this.floatingChatInput = '';
        this.floatingChatAsking = true;
        this.trimFloatingChatMessages();
        await this.service.render();
        this.scrollFloatingChatToBottom();

        try {
            const response: any = await this.service.request.post('/wiz/api/page.agent/ask', {
                message,
                source: 'floating'
            });
            if (!response || response.code !== 200) {
                throw new Error(response?.data?.message || response?.message || '질의를 처리하지 못했습니다.');
            }
            const data = this.floatingPayload(response.data);
            this.floatingChatMessages.push(this.floatingAssistantMessage(data, message));
        } catch (error: any) {
            this.floatingChatMessages.push({
                role: 'error',
                content: error?.message || '질의를 처리하지 못했습니다. 잠시 후 다시 시도해 주세요.'
            });
        }

        this.floatingChatAsking = false;
        this.trimFloatingChatMessages();
        await this.service.render();
        this.scrollFloatingChatToBottom();
    }

    public async openAgentChatFromFloating() {
        this.service.href('/agent/chat');
        this.floatingChatOpen = false;
        await this.service.render();
    }

    public floatingMessageClass(message: any) {
        if (message?.role === 'user') return 'is-user';
        if (message?.role === 'error') return 'is-error';
        return 'is-assistant';
    }

    private floatingPayload(data: any) {
        if (data && data.data) return data.data;
        return data || {};
    }

    private floatingAssistantMessage(data: any, question: string) {
        return {
            role: 'assistant',
            question,
            content: data?.answer || '답변을 생성하지 못했습니다.',
            intent: data?.intent || '',
            dataScope: data?.dataScope || '',
            dataAsOf: data?.dataAsOf || '',
            source: data?.source || '',
            llm: data?.llm || null,
            citations: (data?.citations || []).slice(0, 3),
            deepLinks: (data?.deepLinks || []).slice(0, 3),
            followups: (data?.followups || []).slice(0, 3)
        };
    }

    public handleFloatingChatKeydown(event: KeyboardEvent) {
        if (event.key !== 'Enter' || event.shiftKey || (event as any).isComposing) return;
        event.preventDefault();
        void this.floatingChatAsk();
    }

    public floatingRuntimeItems(message: any) {
        const items: any[] = [];
        const scope = String(message?.dataScope || '');
        if (scope === 'sample') {
            items.push({ label: `샘플 데이터${message?.dataAsOf ? ' · ' + message.dataAsOf + ' 기준' : ''}`, tone: 'sample' });
        } else if (scope === 'no_data') {
            items.push({ label: '일치하는 근거 데이터 없음', tone: 'warning' });
        }
        if (message?.llm?.fallback === true || message?.llm?.degraded === true) {
            items.push({ label: '대체 응답 사용', tone: 'warning' });
        }
        return items;
    }

    private trimFloatingChatMessages() {
        if (this.floatingChatMessages.length > 16) {
            this.floatingChatMessages = this.floatingChatMessages.slice(this.floatingChatMessages.length - 16);
        }
    }

    private scrollFloatingChatToBottom() {
        setTimeout(() => {
            const body = document.querySelector('.nf-floating-chat-body') as HTMLElement;
            if (body) body.scrollTop = body.scrollHeight;
        }, 0);
    }

    private detectTheme() {
        try {
            const saved = localStorage.getItem(this.themeStorageKey);
            if (saved === 'dark' || saved === 'light') return saved;
        } catch (error) { }
        return document.documentElement.getAttribute('data-theme') === 'dark' ? 'dark' : 'light';
    }

    private applyTheme(theme: string) {
        this.theme = theme === 'dark' ? 'dark' : 'light';
        document.documentElement.setAttribute('data-theme', this.theme);
        document.documentElement.style.colorScheme = this.theme;
        const meta = document.querySelector('meta[name="theme-color"]');
        if (meta) meta.setAttribute('content', this.theme === 'dark' ? '#071321' : '#2e6fae');
        try {
            localStorage.setItem(this.themeStorageKey, this.theme);
        } catch (error) { }
    }

    private detectSidebarCollapsed() {
        try {
            return localStorage.getItem(this.sidebarStorageKey) === '1';
        } catch (error) { }
        return false;
    }
}

export default LayoutSidebarComponent;